<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">      
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>运营</el-breadcrumb-item>
          <el-breadcrumb-item>特约商户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-tabs v-model="activeName" >
          <el-tab-pane label="超级管理员信息" name="0" v-if="form.contact_Info">
            <el-form  :model="form" label-width="200px">
              <el-form-item label="超级管理员姓名">
                <el-col :span="11">
                  <el-input v-model="form.contact_Info.contact_name"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="超级管理员身份证件号码">
                <el-col :span="11">
                  <el-input v-model="form.contact_Info.contact_id_number"></el-input>
                </el-col>
              </el-form-item>              
              <el-form-item label="联系手机">
                <el-col :span="11">
                  <el-input v-model="form.contact_Info.mobile_phone"></el-input>
                </el-col>
              </el-form-item>              
              <el-form-item label="联系邮箱">
                <el-col :span="11">
                  <el-input v-model="form.contact_Info.contact_email"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="主体资料" name="1">
            <el-form  :model="form" label-width="200px" v-if="form.subject_Info">
              <el-form-item label="主体类型">
                <el-col :span="11">
                  <el-select v-model="form.subject_Info.subject_type" placeholder="请选择主体类型">
                    <el-option label="个体户" value="SUBJECT_TYPE_INDIVIDUAL"></el-option>
                    <el-option label="企业" value="SUBJECT_TYPE_ENTERPRISE"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-collapse v-model="activecollapse" >
                <el-collapse-item title="营业执照" name="1">
                  <el-form-item label="营业执照照片">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.business_license_info.license_copy">
                        <el-button slot="append" @click="uplpadFile('license_copy')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="统一社会信用代码">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.business_license_info.license_number"></el-input>
                    </el-col>
                  </el-form-item>  
                  <el-form-item label="商户名称">
                    <el-col :span="11">
                      <el-tooltip class="item" effect="dark" content="请填写营业执照上的商户名称，2~110个字符，支持括号" placement="right">
                        <el-input v-model="form.subject_Info.business_license_info.merchant_name"></el-input>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="个体户经营者/法人姓名">
                    <el-col :span="11">
                      <el-tooltip class="item" effect="dark" content="请填写营业执照的经营者/法定代表人姓名" placement="right">
                        <el-input v-model="form.subject_Info.business_license_info.legal_person"></el-input>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="经营者/法人身份证件" name="2">
                  <el-form-item label="身份证人像面照片">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.id_card_copy">
                        <el-button slot="append" @click="uplpadFile('id_card_copy')" >上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="身份证国徽面照片">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.id_card_national">
                        <el-button slot="append" @click="uplpadFile('id_card_national')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>  
                  <el-form-item label="身份证姓名">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.id_card_name"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="身份证号码">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.id_card_number"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="身份证有效期开始时间">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.card_period_begin"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="身份证有效期结束时间">
                    <el-col :span="11">
                      <el-input v-model="form.subject_Info.identity_Info.id_Card_Info.card_period_end"></el-input>
                    </el-col>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>             
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="经营资料" name="2">
            <el-form  :model="form" label-width="200px" v-if="form.business_Info">
              <el-form-item label="商户简称">
                <el-col :span="11">
                  <el-tooltip class="item" effect="dark" content="在支付完成页向买家展示，需与微信经营类目相关。示例值：张三餐饮店" placement="right">
                    <el-input v-model="form.business_Info.merchant_shortname"></el-input>
                  </el-tooltip>
                </el-col>
              </el-form-item>
              <el-form-item label="客服电话">
                <el-col :span="11">
                  <el-input v-model="form.business_Info.service_phone"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="经营场景">
                <el-col :span="11">
                  <el-checkbox-group v-model="sales_scenes_type">
                    <el-checkbox label="SALES_SCENES_STORE">线下门店</el-checkbox>
                    <el-checkbox label="SALES_SCENES_MP">公众号</el-checkbox>
                    <el-checkbox label="SALES_SCENES_MINI_PROGRAM" >小程序</el-checkbox>
                  </el-checkbox-group>
                </el-col>
              </el-form-item>
              <el-collapse v-model="activecollapse" >
                <el-collapse-item title="线下门店"  v-if="sales_scenes_type.indexOf('SALES_SCENES_STORE')>-1"  name="1">
                  <el-form-item label="门店名称">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.biz_store_name">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="门店省市编码">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.biz_address_code"/>
                    </el-col>
                  </el-form-item>  
                  <el-form-item label="门店地址">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.biz_store_address"/>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="门店门头照片">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.store_entrance_pic">
                        <el-button slot="append" @click="uplpadFile('store_entrance_pic')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="店内环境照片">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.indoor_pic">
                        <el-button slot="append"  @click="uplpadFile('indoor_pic')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="线下场所对应的商家APPID">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.biz_Store_Info.biz_sub_appid"/>
                    </el-col>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="公众号"  v-if="sales_scenes_type.indexOf('SALES_SCENES_MP')>-1"  name="2">
                  <el-form-item label="服务商公众号APPID">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.mp_Info.mp_appid">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="商家公众号APPID">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.mp_Info.mp_sub_appid">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="公众号页面截图">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.mp_Info.mp_pics">
                        <el-button slot="append" @click="uplpadFile('mp_pics')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item title="小程序"  v-if="sales_scenes_type.indexOf('SALES_SCENES_MINI_PROGRAM')>-1"  name="3">
                  <el-form-item label="商家小程序APPID">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.mini_program_info.mini_program_sub_appid">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="小程序截图">
                    <el-col :span="11">
                      <el-input v-model="form.business_Info.sales_Info.mini_program_info.mini_program_pics">
                        <el-button slot="append" @click="uplpadFile('mini_program_pics')">上传</el-button>
                      </el-input>
                    </el-col>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>             
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="结算规则" name="3">
            <el-form  :model="form" label-width="200px" v-if="form.settlement_Info">
              <el-form-item label="入驻结算规则ID">
                <el-col :span="11">
                  <el-input v-model="form.settlement_Info.settlement_id"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="所属行业">
                <el-col :span="11">
                  <el-input v-model="form.settlement_Info.qualification_type"></el-input>
                </el-col>
              </el-form-item>              
              <el-form-item label="特殊资质图片(选填)">
                <el-col :span="11">
                  <el-input v-model="form.settlement_Info.qualifications"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="优惠费率活动ID">
                <el-col :span="11">
                  <el-input v-model="form.settlement_Info.activities_id" placeholder="查看参数说明"></el-input>
                </el-col>
              </el-form-item>            
              <el-form-item label="优惠费率活动值">
                <el-col :span="11">
                  <el-input v-model="form.settlement_Info.activities_rate" placeholder="查看参数说明"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="结算银行账户" name="4">
            <el-form  :model="form" label-width="200px" v-if="form.bank_Account_Info">
              <el-form-item label="账户类型">
                <el-col :span="11">
                  <el-select v-model="form.bank_Account_Info.bank_account_type" placeholder="请选择账户类型">
                    <el-option label="对公银行账户" value="BANK_ACCOUNT_TYPE_CORPORATE"></el-option>
                    <el-option label="营者个人银行卡" value="BANK_ACCOUNT_TYPE_PERSONAL"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="开户名称">
                <el-col :span="11">
                  <el-input v-model="form.bank_Account_Info.account_name"></el-input>
                </el-col>
              </el-form-item>              
              <el-form-item label="开户银行">
                <el-col :span="11">
                  <el-input v-model="form.bank_Account_Info.account_bank"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="开户银行省市编码">
                <el-col :span="11">
                  <el-input v-model="form.bank_Account_Info.bank_address_code"></el-input>
                </el-col>
              </el-form-item>            
              <el-form-item label="开户银行全称（含支行）">
                <el-col :span="11">
                  <el-input v-model="form.bank_Account_Info.bank_name"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="银行账号">
                <el-col :span="11">
                  <el-input v-model="form.bank_Account_Info.account_number"></el-input>
                </el-col>
              </el-form-item>   
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="补充材料(选填)" name="5">
             <el-form  :model="form" label-width="200px" v-if="form.addition_Info">              
              <el-form-item label="补充材料">
                <el-col :span="11">
                  <el-input v-model="form.addition_Info.business_addition_pics">
                    <el-button slot="append" @click="uplpadFile('business_addition_pics')">上传</el-button>
                  </el-input>
                </el-col>
              </el-form-item>     
              <el-form-item label="补充说明">
                <el-col :span="11">
                  <el-input v-model="form.addition_Info.business_addition_msg"></el-input>
                </el-col>
              </el-form-item>   
            </el-form>
          </el-tab-pane>
        </el-tabs>    
        <el-row class="top10">
          <el-link href="https://pay.weixin.qq.com/wiki/doc/apiv3_partner/terms_definition/chapter1_1_3.shtml#part-6" target="_blank">查看参数说明</el-link>
        </el-row>
        <el-row class="top10">      
          <el-button type="primary"  @click="Save">保存信息</el-button>
          <el-button type="primary" @click="Submit">提交审核</el-button>         
        </el-row> 
      </div>
    </section>    
    <UpdloadWechatFile v-bind:dialogUpdloadWechatFile="dialogUpdloadWechatFile"  @UpdateUpdloadWechatFile="UpdateUpdloadWechatFile"></UpdloadWechatFile>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import qs from 'qs'   
  import UpdloadWechatFile from '@/components/UpdloadWechatFile'
  
  export default {
    props:{
    },
    data (){
      return {
        activeName:0,
        activecollapse:'',
        form:{},
        sales_scenes_type:[],
        dialogUpdloadWechatFile:{
          isShow:false
        },
        uploadFileName:''
      }
    },
    computed:{
    },
    created(){
    },
    mounted(){
      this.getData()
    },
    methods:{     
      getData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Wechat/MerchantGet',         
          params:{
            id:that.$route.params.Id
          }
        }).then(function (resp) {
          that.form = resp.data.data  
          that.sales_scenes_type = JSON.parse(that.form.business_Info.sales_Info.sales_scenes_type)
        })
      },
      SetStep:function (index) {
        this.activeStep = index
      },
      Save:function(){ 
        this.form.business_Info.sales_Info.sales_scenes_type = JSON.stringify(this.sales_scenes_type)
        var that = this     
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Wechat/MerchantSave',         
          data: that.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Submit:function(){
        this.form.business_Info.sales_Info.sales_scenes_type = JSON.stringify(this.sales_scenes_type)
        var that = this     
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Wechat/MerchantSubmit',         
          data: that.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      uplpadFile:function(id){
        this.uploadFileName = id 
        this.dialogUpdloadWechatFile.isShow = true
      },
      UpdateUpdloadWechatFile:function(mediaId){

      }
    },
    components:{    
      UpdloadWechatFile
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.top10
  margin-top 10px
  text-align  center
</style>